// @flow
import defaultIcon from './static/theme-dark-default@2x.png';
import darkIcon from './static/theme-dark-mint@2x.png';
import flatIcon from './static/theme-flat@2x.png';
import bubblegumIcon from './static/theme-bubblegum@2x.png';
import minimalIcon from './static/theme-minimal@2x.png';
import windowsIcon from './static/theme-windows-95@2x.png';
import poseidonIcon from './static/theme-poseidon@2x.png';
import {PAYWEB_US_BANK_ACCOUNT_TEST_PUBLIC_KEY} from '../PaymentElementDemo/constants';

export const THEMES = {
  bubblegum: {
    key: 'bubblegum',
    label: 'Bubblegum',
    background: 'purple100',
    sortingWeight: 40,
    icon: bubblegumIcon,
    appearance: {
      theme: 'flat',
      variables: {
        fontWeightNormal: '500',
        borderRadius: '2px',
        colorBackground: 'white',
        colorPrimary: '#DF1B41',
        colorPrimaryText: 'white',
        spacingGridRow: '15px',
      },
      rules: {
        '.Label': {
          marginBottom: '6px',
        },
        '.Tab, .Input, .Block': {
          boxShadow: '0px 3px 10px rgba(18, 42, 66, 0.08)',
          padding: '12px',
        },
      },
    },
  },
  default: {
    key: 'default',
    label: 'Stripe',
    background: 'offset',
    sortingWeight: 0,
    icon: defaultIcon,
    appearance: {
      theme: 'stripe',
    },
  },
  night: {
    key: 'night',
    label: 'Night',
    background: 'gray900',
    sortingWeight: 10,
    icon: darkIcon,
    tabColor: 'green200',
    appearance: {
      theme: 'night',
      labels: 'floating',
    },
  },
  flat: {
    key: 'flat',
    label: 'Flat',
    background: 'white',
    sortingWeight: 20,
    icon: flatIcon,
    tabColor: 'gray50',
    appearance: {
      theme: 'flat',
    },
  },
  minimal: {
    key: 'minimal',
    label: 'Minimal',
    background: 'white',
    sortingWeight: 30,
    icon: minimalIcon,
    tabColor: 'gray50',
    appearance: {
      theme: 'flat',
      variables: {
        fontFamily: ' "Gill Sans", sans-serif',
        fontLineHeight: '1.5',
        borderRadius: '10px',
        colorBackground: '#F6F8FA',
        colorPrimaryText: '#262626',
      },
      rules: {
        '.Block': {
          backgroundColor: 'var(--colorBackground)',
          boxShadow: 'none',
          padding: '12px',
        },
        '.Input': {
          padding: '12px',
        },
        '.Input:disabled, .Input--invalid:disabled': {
          color: 'lightgray',
        },
        '.Tab': {
          padding: '10px 12px 8px 12px',
          border: 'none',
        },
        '.Tab:hover': {
          border: 'none',
          boxShadow:
            '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
        },
        '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
          border: 'none',
          backgroundColor: '#fff',
          boxShadow:
            '0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
        },
        '.Label': {
          fontWeight: '500',
        },
      },
    },
  },
  windows: {
    key: 'windows',
    label: 'Ninety Five',
    background: 'gray200',
    sortingWeight: 50,
    icon: windowsIcon,
    appearance: {
      theme: 'none',
      variables: {
        fontFamily: 'Verdana',
        fontLineHeight: '1.5',
        borderRadius: '0',
        colorBackground: '#dfdfdf',
      },
      rules: {
        '.Input': {
          backgroundColor: '#ffffff',
          boxShadow:
            'inset -1px -1px #ffffff, inset 1px 1px #0a0a0a, inset -2px -2px #dfdfdf, inset 2px 2px #808080',
        },
        '.Input--invalid': {
          color: '#DF1B41',
        },
        '.Tab, .Block': {
          boxShadow:
            'inset -1px -1px #0a0a0a, inset 1px 1px #ffffff, inset -2px -2px #808080, inset 2px 2px #dfdfdf',
        },
        '.Tab:hover': {
          backgroundColor: '#eee',
        },
        '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
          backgroundColor: '#ccc',
        },
      },
    },
  },
  darkBlue: {
    key: 'darkBlue',
    label: 'Dark Blue',
    background: 'blue800',
    sortingWeight: 60,
    icon: poseidonIcon,
    tabColor: 'yellow200',
    appearance: {
      theme: 'night',
      variables: {
        fontFamily: 'Sohne, system-ui, sans-serif',
        fontWeightNormal: '500',
        borderRadius: '8px',
        colorBackground: '#0A2540',
        colorPrimary: '#EFC078',
        colorPrimaryText: '#1A1B25',
        colorText: 'white',
        colorTextSecondary: 'white',
        colorTextPlaceholder: '#727F96',
        colorIconTab: 'white',
        colorLogo: 'dark',
      },
      rules: {
        '.Input, .Block': {
          backgroundColor: 'transparent',
          border: '1.5px solid var(--colorPrimary)',
        },
      },
    },
  },
};

// payments-web-bots+payment-intents@stripe.com test account
const PAYWEB_PAYMENT_INTENTS_TEST_PUBLIC_KEY =
  'pk_test_Sds05L2renhqjHCunKB9i5i2';
// pjsevason+klarna-test@stripe.com test DE account
const PAYWEB_KLARNA_TEST_PUBLIC_KEY =
  'pk_test_51JIF4wIPedPoXQNKIe7fGQdOi9GJ4c01DlI5TjKsWCZSmyNah5VZGXGznsyzQQZaJdogsE0qtzG3FAmiPEvC9LqZ00lGPrTU19';

// Hard coded the preference payment method order for each country
export const LOCATIONS = {
  de: {
    key: 'de',
    label: 'DE',
    paymentMethodOrders: ['giropay', 'eps', 'sofort', 'p24'],
    paymentMethodTypes: [
      'giropay',
      'eps',
      'sofort',
      'p24',
      'card',
      'bancontact',
      'ideal',
    ],
    currency: 'eur',
    locale: 'de',
    publicKey: PAYWEB_KLARNA_TEST_PUBLIC_KEY,
  },
  cn: {
    key: 'cn',
    label: 'CN',
    paymentMethodOrders: ['alipay'],
    paymentMethodTypes: ['alipay', 'card'],
    currency: 'cny',
    locale: 'zh',
    publicKey: PAYWEB_PAYMENT_INTENTS_TEST_PUBLIC_KEY,
  },
  us: {
    key: 'us',
    label: 'US',
    paymentMethodOrders: ['card'],
    paymentMethodTypes: ['card', 'afterpay_clearpay'],
    currency: 'usd',
    locale: 'en',
    publicKey: PAYWEB_US_BANK_ACCOUNT_TEST_PUBLIC_KEY,
  },
};
